import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Collapse from './icon-collapse.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Collapse {...validProps} />;
}
SvgComponent.iconName = 'collapse';

/**
 * @deprecated This is a legacy icon
 */
export const CollapseIcon = svgIconWrapper(SvgComponent);
